import _ from "lodash";
import { Types } from "../actions/payslipActions";

const defaultState = {
	my: {},
};

const payslipReducers = (state = defaultState, action) => {
	console.log("inpayslipReducers", action.type);
	switch (action.type) {
		case Types.PAYSLIP_SEND_MODAL: {
			let newState = _.cloneDeep(state);

			if (!newState.sendPayslipModal) {
				newState.sendPayslipModal = {};
			}

			newState.sendPayslipModal = {
				...newState.sendPayslipModal,
				status: action.status,
				sending: false,
				sent: false,
			};
			if (action.status) newState.payroll.currentPayPeriodId = action.id;
			else delete newState.payroll.currentPayPeriodId;
			console.log("sendModal");

			return newState;
		}
		case Types.PAYSLIP_SENDING: {
			let newState = _.cloneDeep(state);

			newState.sendPayslipModal = {
				...newState.sendPayslipModal,
				sending: true,
			};

			return newState;
		}
		case Types.PAYSLIP_SENT: {
			let newState = _.cloneDeep(state);

			newState.sendPayslipModal = {
				...newState.sendPayslipModal,
				sending: action.status ? false : undefined,
				sent: action.status ? true : undefined,
			};

			return newState;
		}
		case Types.PAYSLIP_AGREEMENT_LOADING: {
			let newState = _.cloneDeep(state);

			newState.employee.loading = {
				...newState.employee.loading,
				payslips: action.status ? action.status : undefined,
			};

			return newState;
		}
		case Types.PAYSLIP_UPDATING: {
			let newState = _.cloneDeep(state);

			newState.payslipHistory.updating = action.status ? true : undefined;
			newState.payslipHistory.payslips = action.status ? undefined : newState.payslipHistory.payslips;

			return newState;
		}
		case Types.PAYSLIP_UPDATE: {
			let newState = { ...state };

			console.log("inPayslipUpdate");
			newState.payslipHistory.payslips = _.orderBy(action.payload, ["employee"], ["asc"]);

			// if (action.payload[0] && action.payload[0].name){
			//   newState.fssReports = _.orderBy(action.payload,['name'],['asc'])
			// }

			newState.payslipHistory.updating = true;
			// console.log('inPayslipUpdate',newState.payslipHistory)

			return newState;
		}
		case Types.PAYSLIP_DOWNLOADING: {
			let newState = _.cloneDeep(state);
			const index = newState.payslipHistory.payslips.find((i) => i.id == action.id);

			newState.payslipHistory.payslips[index] = {
				...newState.payslipHistory.payslips[index],
				downloading: action.status,
			};

			return newState;
		}
		case Types.PAYSLIP_IMPORT_UPLOAD_TEMPLATE: {
			let newState = _.cloneDeep(state);
			newState.payslipImport.template = action.template;
			return newState;
		}
		case Types.PAYSLIP_IMPORT_SHOW_MODAL: {
			let newState = _.cloneDeep(state);
			newState.payslipImport.showModal = action.status;
			if (!action.status) newState.payslipImport = { results: {} };
			return newState;
		}
		case Types.PAYSLIP_FILE_UPLOADING: {
			let newState = _.cloneDeep(state);

			newState.payslipImport = {
				...newState.payslipImport,
				uploading: true,
			};

			return newState;
		}
		case Types.PAYSLIP_FILE_UPLOADED: {
			let newState = _.cloneDeep(state);

			newState.payslipImport = {
				...newState.payslipImport,
				uploading: false,
				uploadResults: action.payload,
			};

			return newState;
		}
		case Types.PAYSLIP_IMPORT_DATA_PROCESSING: {
			let newState = _.cloneDeep(state);
			newState.payslipImport.processingFile = action.key;
			return newState;
		}
		case Types.PAYSLIP_IMPORT_DATA_PROCESSED: {
			let newState = _.cloneDeep(state);
			newState.payslipImport.results = {
				processed: action.processed,
				errors: action.errors,
				warnings: action.warnings,
			};
			newState.payslipImport.processingFile = null;
			return newState;
		}
		case Types.PAYSLIP_SET_TAX_MODAL: {
			let newState = _.cloneDeep(state);

			newState.payslipHistory.taxModal = {
				show: action?.show,
				tax: action?.tax || state?.payslipHistory?.taxModal?.tax,
			};

			return newState;
		}
		default:
			return state;
	}
};

export default payslipReducers;
